export default {
    apartmentCreate: "APARTMENT_CREATE",
    apartmentCreationSuccess: "APARTMENT_SUCCESS_MESSAGE",
    apartmentUpdate: "APARTMENT_UPDATE",
    apartmentForm: {
        firstSectionTitle: "FIRST_SECTION_TITLE",
        secondSectionTitle: "SECOND_SECTION_TITLE",
        correspondingBlock: "APARTMENT_CORRESPONDING_BLOCK",
        number: "APARTMENT_NUMBER",
        tenant: "APARTMENT_TENANT",
        owner : "APARTMENT_OWNER",
        floor: "APARTMENT_FLOOR",
        surface: "APARTMENT_SURFACE",
        type: "APARTMENT_TYPE",
        buildingName: "APARTMENT_BUILDING",
        activity: "APARTMENT_ACTIVITY",
        function: "APARTMENT_FUNCTION",
        acquisition: "APARTMENT_ACQUISITION",
        excludeMaintenanceCost: "APARTMENT_EXCLUDE_MAINTENANCE_COST",
        category: "APARTMENT_CATEGORY",
        nbParking: "APARTMENT_NB_PARKING",
        nbBasement: "APARTMENT_NB_BASEMENT",
        email: "APARTMENT_EMAIL",
        landline: "APARTMENT_LANDLINE",
        nbFloor: "APARTMENT_NB_FLOOR",
        constructionDate: "APARTMENT_CONSTRUCTION_DATE",
        address: "APARTMENT_ADDRESS",
        maintenanceReferent: "APARTMENT_MAINTENANCE_REFERENT",
        vehicleReferent: "APARTMENT_VEHICLE_REFERENT",
        hub: "APARTMENT_HUB"
    },
    apartmentDeleteMessage: "APARTMENT_DELETE_MESSAGE",
    apartmentExcludeFromMaintenanceCost: "APARTMENT_EXCLUDE_FROM_MAINTENANCE_COST",
    apartmentReferent: "APARTMENT_REFERENT",
    apartmentEdit: "APARTMENT_EDIT",
    apartmentDelete: "APARTMENT_DELETE",
    numApartment: "NUM_APARTMENT",
    apartmentGroundFloor: "APARTMENT_GROUND_FLOOR",
    apartmentAddLocationNumber: "APARTMENT_ADD_LOCATION_NUMBER",
    apartmentZoneModalTitle: "APARTMENT_ZONE_MODAL_TITLE",
    apartmentZoneModalTitleUP: "APARTMENT_ZONE_MODAL_TITLE_UP",
    apartmentDeleteZone: "APARTMENT_DELETE_ZONE",
    apartmentZoneName: "APARTMENT_ZONE_NAME",
    apartmentNoZone: "APARTMENT_NO_ZONE"
}



// WEBPACK FOOTER //
// ./src/locales/apartment/index.ts